import React, {useState, useContext} from "react"
import { UserContext } from '../../context/UserContext'
import { v4 as uuidv4 } from 'uuid'
import { ConfigurationContext } from '../../context/ConfigurationContext'
import './QuestionRadio.css'

const QuestionRadioStart = ({callback}) => {
  const {
    setConfigurationId,
  } = useContext(UserContext);
  const { configurations } = useContext(ConfigurationContext);

  

  const [index, setIndex] = useState(null);
  
  function handleClick(e) {
    callback(e.target.dataset.index);
    setConfigurationId(e.target.dataset.index);
    setIndex(e.target.dataset.index);
    
  }

  const wrapClasses = 'col-span-12 wrap lg:col-span-6 form-group inline-block w-full sm:w-auto relative px-5 pb-5 bg-white p-4 pl-10 border-pinkish border rounded-xl ';
  const wrapClassesActive = 'active col-span-12 wrap lg:col-span-6 form-group inline-block w-full sm:w-auto relative px-5 pb-5 bg-white p-4 pl-10 border-pinkish border rounded-xl ';
  return (
    <>
      <p className={"text-gray text-size-12 line-height-12 uppercase hidden sm:block"} key={uuidv4()}>Välj ett alternativ</p>
      <div className={"grid grid-cols-12 gap-y-4 gap-x-8"} key={uuidv4()}>
      { 
      configurations.items.map( (item, i) => {
        return (
          <div id={ 'wrap-' + i } className={ Number(index) === item.id ? wrapClassesActive : wrapClasses } key={uuidv4()}>
            <input
              key={uuidv4()}
              type="radio" 
              id={ 'input-' + i }
              _id= {i}
              name={ 'test' } 
              value={ item.option }
              data-index={item.id}
              onChange={handleClick}
              checked={Number(index) === item.id ? true : false}
            />

            <label 
              key={uuidv4()}
              className="text-xl sm:text-2xl font-medium px-5 text-black pl-4 text-grayish font-[500] text-size-15" 
              htmlFor={ 'input-' + i }
            >
              <span className={"checkmark"}></span>
              {item.title}
            </label>
          </div>
          )
        }
        )
      }

      <span className={"mt-8 block text-size-12 text-grayish-2 block sm:hidden"}>{ 'Välj det alternativ som passar bäst' }</span>
      </div>
    </>
  );
};

export default QuestionRadioStart;
